import { render, staticRenderFns } from "./CopyReceiveDate.vue?vue&type=template&id=93632906&"
import script from "./CopyReceiveDate.vue?vue&type=script&lang=js&"
export * from "./CopyReceiveDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports